import { InputMain } from '@/components/ui/inputs'
import PhoneInput from 'react-phone-input-2'
import { Controller, useForm } from 'react-hook-form'
import { validationSchemaForCallback } from '@/components/ui/common-form-signup/validationScheme'
import useYupValidationResolver from '@/hooks/useYupValidationResolver'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import authSelector from '@/redux/selectors/auth'
import { sendGeneralEmail } from '@/services/novu-notifications'

import SvgSpinner from '@/components/icons/spinner'
import { toast } from 'react-hot-toast'
import 'react-phone-input-2/lib/style.css'
import { trackEventMixpanel } from '@/utils/mixpanel'
import { SUPPORT_REQUEST } from '@/utils/mixpanel/eventNames'

export default function RequestCallback({ onClose, buttonText }) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const { user } = useSelector(authSelector)

  const resolver = useYupValidationResolver(validationSchemaForCallback)
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onBlur',
    resolver,
    defaultValues: {
      phone: `${user && user?.phone ? user?.phone : ''}`,
    },
  })

  async function onSubmit(formData) {
    if (user.role != 'student') {
      return setError('You are not authorized to perform this action.')
    }
    if (!buttonText) {
      try {
        setIsLoading(true)
        await sendGeneralEmail({
          inAppMsg: 'Student requested a call',
          inAppRedirectTo: `/`,
          emailSubject: 'Student requested a call',
          emailMsg: 
            `<table align="center" width="100%" class="" data-id="react-email-section" border="0" cellPadding="0" cellSpacing="0" role="presentation">
              <tbody>
                <tr>
                  <td>
                    <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:600">${
                      user?.name
                    } ${buttonText ? buttonText : 'requested a callback'}.</p>
                    <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:600">Details:</p>
                    <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:400"></p>
                    <table cellSpacing="0" cellPadding="0">
                      <tr style="color:rgb(52,64,84);font-weight:400;font-size:1.125rem;line-height:1.75rem">
                        <td width="24" align="center" valign="top"><span style="font-size:1.875rem;line-height:1.5rem"> •</span></td>
                        <td align="left" valign="top">Name: ${user?.name}</td>
                      </tr>
                      <tr style="color:rgb(52,64,84);font-weight:400;font-size:1.125rem;line-height:1.75rem">
                        <td width="24" align="center" valign="top"><span style="font-size:1.875rem;line-height:1.5rem"> •</span></td>
                        <td align="left" valign="top">Phone: ${formData?.phone}</td>
                      </tr>
                    </table>
                    <p></p>
                  </td>
                </tr>
              </tbody>
            </table>`,
          userId: 'aiVRxdT8DwM2goODzhtsnyNUHJ03',
          recipientEmail: 'info@examsolutions.net',
        })

        onClose()
        // toast.success(
        //   `Thank you for requesting a call. We'll call you within 24 hours.`,
        // )
      } catch (error) {
        toast.error('There was an error. Please try again later.')
        console.log('err callback:', error)
        onClose()
      } finally {
        setIsLoading(false)
      }
    }
    // request mail
    if (buttonText == 'Request for Support') {
      try {
        setIsLoading(true)
        trackEventMixpanel(SUPPORT_REQUEST, {
          'UserID': user?.uid,
          'Phone Number': formData?.phone
        })

        // send email to admin
        await sendGeneralEmail({
          inAppMsg: 'Student request for Support',
          inAppRedirectTo: `/`,
          emailSubject: 'Student request for Support',
          emailMsg: 
          `<table align="center" width="100%" class="" data-id="react-email-section" border="0" cellPadding="0" cellSpacing="0" role="presentation">
            <tbody>
              <tr>
                <td>
                <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:600">Dear Support Team, </p>
                  <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:600">I need urgent support for a critical issue.</p>
                  <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:600">Please prioritize this matter as it's impacting my productivity. Here are the details you need: </p>

                  <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:600">Details:</p>
                  <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:400"></p>
                  <table cellSpacing="0" cellPadding="0">
                    <tr style="color:rgb(52,64,84);font-weight:400;font-size:1.125rem;line-height:1.75rem">
                      <td width="24" align="center" valign="top"><span style="font-size:1.875rem;line-height:1.5rem"> •</span></td>
                      <td align="left" valign="top">Name: ${user?.name}</td>
                    </tr>
                    <tr style="color:rgb(52,64,84);font-weight:400;font-size:1.125rem;line-height:1.75rem">
                      <td width="24" align="center" valign="top"><span style="font-size:1.875rem;line-height:1.5rem"> •</span></td>
                      <td align="left" valign="top">Phone: ${formData?.phone}</td>
                    </tr>
                  </table>
                  <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:600">Thank you,</p>
                  <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:600">${user?.name}</p>

                </td>
              </tr>
            </tbody>
          </table>`,
          userId: 'aiVRxdT8DwM2goODzhtsnyNUHJ03',
          recipientEmail: 'info@examsolutions.net',
        })
        // send email to client
        await sendGeneralEmail({
          inAppMsg: 'Request for Support',
          inAppRedirectTo: `#`,
          emailSubject: 'Your request for Support',
          emailMsg: 
          `<table align="center" width="100%" class="" data-id="react-email-section" border="0" cellPadding="0" cellSpacing="0" role="presentation">
            <tbody>
              <tr>
                <td>
                <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:600">Dear ${user?.name} </p>
                  <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:600">Thank you for contacting us about the urgent support request. Our team is currently investigating the issue and will provide an update soon. We appreciate your patience and understanding..</p>

                  <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:600">Best regards,</p>
                  <p data-id="react-email-text" style="font-size:1.125rem;line-height:1.75rem;margin:16px 0;color:rgb(52,64,84);font-weight:600">Support Team</p>

                </td>
              </tr>
            </tbody>
          </table>`,
          userId: user?.uid,
          recipientEmail: user?.email,
        })
        setIsLoading(true)
        onClose()
        toast.success(
          `Thank you for requesting. We'll will get back to you in 24 hours.`,
        )
      } catch (error) {
        toast.error('There was an error. Please try again later.')
        console.log('err callback:', error)
        onClose()
      } finally {
        setIsLoading(false)
      }
    }
  }

  return (
    <div className="flex flex-col justify-center flex-1 mt-5 sm:mt-0 item-center">
      <div className="w-full mt-2 sm:mx-auto md:w-[500px]">
        <div className="py-2 bg-white sm:rounded-lg">
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-2">
            <InputMain className="sm:gap-2 sm:border-b-0">
              <InputMain.Label
                label="Phone"
                htmlFor="Phone"
                className="text-left"
              />
              <>
                <Controller
                  name="phone"
                  control={control}
                  defaultValue=""
                  render={({ field }) => {
                    return (
                      <div className="relative text-left">
                        <PhoneInput
                          country="gb"
                          inputProps={{
                            name: 'phone',
                            id: 'phone',
                            type: 'tel',
                          }}
                          containerClass="w-full rounded-lg relative mt-1 shadow-sm block phone-input"
                          inputClass="h-11 flex-1 block w-full min-w-0 text-v8-ink placeholder:text-v8-mut border-v8-line focus:ring-v8-blue focus:border-v8-blue rounded-lg sm:text-base"
                          dropdownClass="text-black p-1 rounded-lg"
                          buttonClass="hover:rounded-l-lg rounded-l-lg bg-white"
                          {...field}
                          ref={null}
                        />
                        {errors['phone']?.message && (
                          <div className="mt-2 text-xs text-red-600 text-start">
                            <span className="text-xs text-red-600 ">
                              {errors['phone']?.message}
                            </span>
                          </div>
                        )}
                      </div>
                    )
                  }}
                />
              </>
            </InputMain>

            {error && <div className="text-red-600 text-lg">{error}</div>}
            <button
              disabled={isLoading}
              type="submit"
              className="w-full py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm disabled:bg-v8-mut bg-v8-blue focus:outline-none focus:ring-offset-0 focus:ring-0 hover:bg-v8-blue transition duration-300"
            >
              {isLoading && <SvgSpinner />}
              {buttonText ? buttonText : 'Request Callback'}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
